jQuery(document).ready(function ($) {
    let surveyTags = [];
    let surveyAnswers = [];
    $('#webinar-survey-modal').hide();
    $('.survey-modal-trigger').on('click',function(e){
        // if modal doesn't exist, fallback to default href link
        if (!!$('#webinar-survey-modal').length) {
            e.preventDefault();
            $('#webinar-survey-modal').addClass('active').fadeIn(100);
        }
    })
    $('.survey-container').on('click','.survey-answer',function(){
        surveyTags.push($(this).attr('data-answer-tag'))
        surveyAnswers.push($(this).attr('data-answer-val'));
        let nextId = $(this).attr('data-next');
        let nextQuestion = $('.survey-container label[data-question-id="'+nextId+'"]')
        let nextIndex = nextQuestion.attr('data-question-index');
        let lastIndex = $('.survey-container label[data-question-id="end"]').attr('data-question-index');
        let percentComplete = Math.ceil((nextIndex/lastIndex)*100);
        $('.survey-progress .bar').css('width',percentComplete+'%');
        if(nextId === 'end'){
            $('.survey-container h2').html('Your video is ready!<br>Enter your email to watch now...');
            $('.survey-progress').hide();
        }
        $('.survey-container label').removeClass('active');
        nextQuestion.addClass('active')
    });

    $('.modal').on('click',function(e){
       if(!$('body').hasClass('webinar-survey') && e.target === $('.modal')[0]){
           $(this).fadeOut();
       }
    });

    $('.survey-container').on('click','button',function(e){
        e.preventDefault();

        let submitButton = $(this);
        submitButton.prop('disabled', true);

        let form = $('#survey-form');
        form.find('.form-message').text('').removeClass('error').hide();
        let emailInput = $('input[name="survey[email]"]');
        let email = emailInput.val().trim();


        if (!email) {
            form.find('.form-message').text('*Email is required').show();
            return false;
        }



        $.ajax({
            type: "POST",
            url: accountingcoach.ajax_url,
            data: {
                action: 'check_webinar_email_existence',
                email: email
            },
            success: function (response) {
                const data = JSON.parse(response);

                if (data.exists) {
                    form.find('.form-message').text('*Unfortunately, this video is not available to existing subscribers.').show();
                    submitButton.prop('disabled', false);
                } else {
                    $('input[name="survey[tags]"]').val(surveyTags.join());
                    $('input[name="survey[answers]"]').val(surveyAnswers.join());
                    $('input[name="survey[type]"]').val('modal');
                    form.submit();
                }
            },
            error: function (xhr, status, error) {
                console.error("An error occurred: " + error);
            }
        });

    });


});
